<template>
  <div class="section pt-0">
    <div class="section">
      <div class="columns">
        <div class="column">
          <h1 class="title is-1">Produktverwaltung</h1>
        </div>
      </div>
    </div>
    <div class="section pt-0">
      <div class="columns">
        <div class="column">
          <div class="is-flex">
            <h4
              class="title is-4 is-clickable"
              :class="activeTab === 0 ? '' : 'has-text-grey-light'"
              @click="activeTab = 0"
            >
              Seitenstruktur
            </h4>
            <h4 class="title is-4 has-text-grey-light mx-3">|</h4>
            <h4
              class="title is-4 is-clickable"
              :class="activeTab === 1 ? '' : 'has-text-grey-light'"
              @click="activeTab = 1"
            >
              Subprodukte
            </h4>
          </div>
          <div v-if="activeTab === 0" class="block">
            <div class="box">
              <b-field label="Produktauswahl" class="mb-5" id="product-select">
                <b-select
                  expanded
                  placeholder="Produkt auswählen..."
                  v-model="selectedProductId"
                  @input="changeProduct"
                  icon="circle"
                  :class="selectedProductStatus"
                >
                  <option
                    v-for="option in products"
                    :value="option.id"
                    :key="option.id"
                  >
                    {{ option.name }}
                  </option>
                </b-select>
              </b-field>
              <RouteTree
                :productId="parseInt(productId, 10)"
                draggable
                @change="onTreeChange"
                @selected="selectRoute"
                height="395px"
              >
                <template v-slot:item-action="{ route, tree, path, select }">
                  <div class="buttons">
                    <a
                      href="#"
                      @click.prevent="
                        select({ route, tree, path, mode: 'edit' })
                      "
                    >
                      <b-icon type="is-grey" icon="pencil-alt"></b-icon>
                    </a>
                    <a href="#" @click.prevent="">
                      <b-icon
                        class="mx-2"
                        type="is-grey"
                        :icon="route.default_visible ? 'eye' : 'eye-slash'"
                      ></b-icon>
                    </a>
                    <a
                      href="#"
                      @click.prevent=""
                      @mousedown="select({ route, tree, path, mode: 'move' })"
                      class="drag-handler"
                    >
                      <b-icon type="is-grey" icon="bars"></b-icon>
                    </a>
                  </div>
                </template>
                <template v-slot:add-button="{ isCreating }">
                  <div
                    class="is-flex is-justify-content-end mt-5"
                    style="width: 100%"
                  >
                    <b-dropdown>
                      <template #trigger>
                        <b-button
                          icon-right="plus"
                          type="is-gold"
                          size="is-small"
                          :disabled="!selectedProductId"
                        ></b-button>
                      </template>
                      <b-dropdown-item @click="prepNewRoute(), isCreating()"
                        >Neue Seite</b-dropdown-item
                      >
                      <b-dropdown-item @click="prepNewDivider"
                        >Neuer Trenner</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                </template>
              </RouteTree>
            </div>
          </div>
          <div v-if="activeTab === 1" class="block">
            <div class="box">
              <b-field label="Produktauswahl" class="mb-5" id="product-select">
                <b-select
                  expanded
                  placeholder="Produkt auswählen"
                  v-model="selectedProductId"
                  @input="changeProduct"
                  icon="circle"
                  :class="selectedProductStatus"
                >
                  <option
                    v-for="option in products"
                    :value="option.id"
                    :key="option.id"
                  >
                    {{ option.name }}
                  </option>
                </b-select>
              </b-field>
              <div class="block">
                <label class="label">Subprodukt</label>
                <div class="is-flex">
                  <b-select
                    expanded
                    placeholder="Subprodukt auswählen..."
                    v-model="selectedGroupId"
                    @input="changeGroup"
                    class="mr-3"
                    style="width: 100%"
                  >
                    <option
                      v-for="option in groups"
                      :value="option.id"
                      :key="option.id"
                    >
                      {{ option.name }}
                    </option>
                  </b-select>
                  <b-button
                    :disabled="!selectedProductId"
                    @click.prevent="prepNewGroup"
                    icon-right="plus"
                    type="is-gold"
                  ></b-button>
                </div>
              </div>
              <RouteTreeGroup
                :groupId="nullToNum(selectedGroupId)"
                @filterEdited="selectGroupRoute"
                @visibilityEdited="changeVisibility"
                height="295px"
              >
                <template v-slot:item-action="{ tree, route, path, select }">
                  <div class="buttons">
                    <a
                      href="#"
                      @click.prevent="
                        select({ tree, route, path, edit: 'filter' })
                      "
                    >
                      <b-icon
                        :type="route.filter ? 'is-gold' : 'is-grey'"
                        icon="filter"
                      ></b-icon>
                    </a>
                    <a
                      href="#"
                      @click.prevent="
                        select({ tree, route, path, edit: 'visibility' })
                      "
                    >
                      <b-icon
                        class="ml-2"
                        :type="
                          route.visible === route.default_visible
                            ? 'is-grey'
                            : 'is-gold'
                        "
                        :icon="route.visible ? 'eye' : 'eye-slash'"
                      ></b-icon>
                    </a>
                  </div>
                </template>
              </RouteTreeGroup>
            </div>
          </div>
        </div>
        <div class="column">
          <div v-if="activeTab === 0 && selectedRoute.id">
            <div class="columns mb-0">
              <div class="column set-height">
                <h4 class="title is-4">Seite bearbeiten</h4>
              </div>
              <div class="column set-height is-narrow">
                <b-tooltip
                  v-if="selectedRoute.id"
                  label="Delete route"
                  position="is-top"
                >
                  <b-button class="is-light" @click="confirmDeleteRoute">
                    <b-icon icon="trash-alt"></b-icon>
                  </b-button>
                </b-tooltip>
              </div>
            </div>
            <div class="block">
              <RouteEdit
                :route="selectedRoute"
                @submit="submitRoute"
              ></RouteEdit>
            </div>
          </div>
          <div v-if="activeTab === 1 && selectedGroup.id">
            <div class="is-flex is-justify-content-space-between mb-0">
              <h4 class="title is-4">Subprodukt bearbeiten</h4>
              <b-tooltip label="Delete group" position="is-top">
                <b-button class="is-light" @click="confirmDeleteGroup">
                  <b-icon icon="trash-alt"></b-icon>
                </b-button>
              </b-tooltip>
            </div>
            <div class="block">
              <SubproductForm :data="selectedGroup" @submit="submitGroup">
                <template #info>
                  <ProductOrgs
                    :subscriberId="theGroupOrg"
                    :height="415"
                    scrollable
                  ></ProductOrgs>
                </template>
              </SubproductForm>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal :active.sync="isRouteModalActive" has-modal-card>
      <template #default="props">
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Seite erstellen</p>
          </header>
          <section class="modal-card-body">
            <RouteEdit
              :route="selectedRoute"
              @submit="submitRoute"
              @close="props.close"
              showCloseBtn
              tagDropup
            ></RouteEdit>
          </section>
        </div>
      </template>
    </b-modal>
    <b-modal :active.sync="isGroupModalActive" has-modal-card>
      <template #default="props">
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Trenner erstellen</p>
          </header>
          <section class="modal-card-body">
            <SubproductForm
              :data="selectedGroup"
              @submit="submitGroup"
              @close="props.close"
              showCloseBtn
            ></SubproductForm>
          </section>
        </div>
      </template>
    </b-modal>
    <b-modal :active.sync="isGroupRouteModalActive" has-modal-card>
      <template #default="props">
        <ValidationObserver v-slot="{ handleSubmit, invalid }">
          <div class="modal-card">
            <header class="modal-card-head">
              <p class="modal-card-title">
                {{ selectedGroup.name }} -
                {{ selectedGroupRoute.name }} bearbeiten
              </p>
            </header>
            <section class="modal-card-body">
              <BInputWithValidation
                rules="max:500"
                type="text"
                label="Tableau-Filter"
                v-model="selectedGroupRoute.filter"
              />
            </section>
            <footer class="modal-card-foot" style="justify-content: end">
              <b-button @click="props.close" class="mr-2">Schließen</b-button>
              <b-button
                type="is-gold"
                :disabled="invalid"
                @click="handleSubmit(updatePermissionGroup(selectedGroupRoute))"
              >
                Speichern
              </b-button>
            </footer>
          </div>
        </ValidationObserver>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import RouteTree from '@/components/editProduct/RouteTree.vue';
import RouteTreeGroup from '@/components/editProduct/RouteTreeGroup.vue';
import RouteEdit from '@/components/editProduct/RouteEdit.vue';
import ProductOrgs from '@/components/editProduct/ProductOrgs.vue';
import BInputWithValidation from '@/components/inputs/BInputWithValidation.vue';
import SubproductForm from '@/components/editProduct/SubproductForm.vue';

export default {
  name: 'ManageProduct',
  components: {
    RouteTree,
    RouteTreeGroup,
    RouteEdit,
    ProductOrgs,
    BInputWithValidation,
    SubproductForm,
  },
  props: ['productId'],
  data() {
    return {
      selectedProductId: this.productId,
      activeTab: 0,
      selectedRoute: {},
      routeModel: {
        product_id: parseInt(this.productId, 10),
        name: null,
        icon: null,
        link: null,
        pos: 0,
        default_visible: false,
        label: false,
        filter: null,
        tags: [],
      },
      dividerModel: {
        product_id: parseInt(this.productId, 10),
        name: null,
        pos: 0,
        default_visible: false,
        label: true,
      },
      isRouteModalActive: false,
      groupModel: {
        product_id: parseInt(this.productId, 10),
        name: '',
      },
      selectedGroupId: null,
      selectedGroup: {},
      isGroupModalActive: false,
      selectedGroupRoute: {
        id: null,
        filter: '',
      },
      isGroupRouteModalActive: false,
      creatingGroup: false,
    };
  },
  computed: {
    ...mapGetters({
      products: 'product/data',
      productById: 'product/dataById',
      productOrg: 'product/org/dataByParentId',
      productGroup: 'product/group/dataByParentId',
      orgGroup: 'org/group/dataByParentId',
    }),
    productIdInt() {
      return parseInt(this.productId, 10);
    },
    selectedProductStatus() {
      return this.productById(this.selectedProductId)?.enabled ? 'enabled' : 'disabled';
    },
    groups() {
      return this.productGroup(this.productId);
    },
    theGroupOrg() {
      const hasGroup = (orgId) => this.orgGroup(orgId).includes(this.selectedGroupId);
      return this.productOrg(this.productId).filter(hasGroup);
    },
  },
  watch: {
    productId(newVal) {
      if (newVal === undefined) this.selectedProductId = null;
      this.routeModel.product_id = parseInt(newVal, 10);
      this.dividerModel.product_id = parseInt(newVal, 10);
      this.groupModel.product_id = parseInt(newVal, 10);
      this.selectedGroupId = null;
      this.selectedRoute = {};
    },
    groups(newVal, oldVal) {
      if (this.creatingGroup && newVal.length > oldVal.length) {
        const newGroup = newVal.filter(
          (group) => !oldVal.find((oldGroup) => oldGroup.id === group.id),
        )[0];
        this.selectedGroupId = newGroup.id;
        this.selectedGroup = { ...newGroup };
        this.creatingGroup = false;
      }
    },
  },
  methods: {
    changeProduct(productId) {
      this.$router.push({ name: 'ManageProductById', params: { productId } });
    },
    selectRoute(route) {
      // exclude children
      const { children, ...routeData } = route;
      // merge product_id
      this.selectedRoute = {
        ...routeData,
        product_id: this.productIdInt,
      };
    },
    prepNewRoute() {
      this.isRouteModalActive = true;
      this.selectedRoute = { ...this.routeModel };
    },
    prepNewDivider() {
      this.isRouteModalActive = true;
      this.selectedRoute = { ...this.dividerModel };
    },
    onTreeChange(data) {
      this.$store.dispatch('product/route/UPDATE', {
        id: data.id,
        parent_id: data.parentId,
        pos: data.newPos,
        product_id: this.productIdInt,
      });
    },
    submitRoute(data) {
      // Decide the request based on route's id
      const operation = data.id ? 'UPDATE' : 'CREATE';
      this.$store.dispatch(`product/route/${operation}`, data);
    },
    deleteRoute() {
      this.$store.dispatch('product/route/DELETE', {
        id: this.selectedRoute.id,
        product_id: this.productIdInt,
      });
      this.selectedRoute = { ...this.routeModel };
    },
    confirmDeleteRoute() {
      this.$buefy.dialog.confirm({
        title: 'Seite löschen',
        // eslint-disable-next-line max-len
        message: `Sind Sie sicher, dass Sie die Seite <b>${this.selectedRoute.name}</b> löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.`,
        confirmText: 'Seite löschen',
        cancelText: 'Abbrechen',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.deleteRoute(),
      });
    },
    changeGroup(groupId) {
      const theGroup = this.groups.find((group) => group.id === groupId);
      this.selectedGroup = { ...theGroup };
    },
    prepNewGroup() {
      this.isGroupModalActive = true;
      this.selectedGroup = { ...this.groupModel };
      this.selectedGroupId = null;
    },
    submitGroup(data) {
      if (data.id) {
        this.$store.dispatch('product/group/UPDATE', data);
      } else {
        this.creatingGroup = true;
        this.$store.dispatch('product/group/CREATE', data);
      }
      this.isGroupModalActive = false;
    },
    changeVisibility(route) {
      const temp = { ...route };
      temp.visible = !route.visible;
      this.updatePermissionGroup(temp);
    },
    selectGroupRoute(route) {
      this.isGroupRouteModalActive = true;
      // eslint-disable-next-line max-len
      this.selectedGroupRoute = { ...route, filter: route.filter ? decodeURI(route.filter) : '' };
    },
    updatePermissionGroup(route) {
      console.log('updateGroupRoute', route);
      this.$store.dispatch('product/group/permission/UPDATE', {
        id: this.selectedGroupId, // permission_group's id
        product_id: this.productIdInt,
        route_id: route.id,
        visible: route.visible,
        filter: route.filter === '' ? null : encodeURI(route.filter),
      });

      if (this.isGroupRouteModalActive) {
        this.isGroupRouteModalActive = false;
      }
    },
    deleteGroup() {
      this.$store.dispatch('product/group/DELETE', {
        id: this.selectedGroup.id,
        product_id: this.productIdInt,
      });
      this.selectedGroupId = null;
      this.selectedGroup = { ...this.groupModel };
    },
    confirmDeleteGroup() {
      this.$buefy.dialog.confirm({
        title: 'Subprodukt löschen',
        // eslint-disable-next-line max-len
        message: `Sind Sie sicher, dass Sie das Subprodukt <b>${this.selectedGroup.name}</b> löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.`,
        confirmText: 'Subprodukt löschen',
        cancelText: 'Abbrechen',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.deleteGroup(),
      });
    },
    nullToNum(data) {
      return data === null ? 0 : data;
    },
  },
  created() {
    this.selectedRoute = { ...this.routeModel };
    this.selectedGroup = { ...this.groupModel };
  },
};
</script>

<style>
#product-select .control.has-icons-left.disabled .icon {
  color: #f14668 !important;
}

#product-select .control.has-icons-left.enabled .icon {
  color: #48c774 !important;
}
</style>
